import {ElementModel} from "../../models/headerModel"

const checkBannerVisibility = (
    quickLinks: ElementModel[] | undefined,
    enableContentBanner: boolean,
    url: string | null,
    showMessageBanner: boolean,
    showStaticBanner: boolean,
    isMedUp: boolean,
    isCountrySelectorInGlobalAppBar: boolean,
): {showCMSBanner: boolean; showaAppBar: boolean} => {
    const trimmedUrl = (url && (url[0] === "/" ? url.substring(1) : url)) || ""
    const isContentBannerExcluded =
        (new URLSearchParams(trimmedUrl).get("excludeContentBanner")?.toLocaleLowerCase() || "") === "true"

    const showCMSBanner = (enableContentBanner && !isContentBannerExcluded) || showMessageBanner
    const showaAppBar =
        (showCMSBanner || ((quickLinks?.length ?? 0) > 0 && isMedUp) || isCountrySelectorInGlobalAppBar) &&
        showStaticBanner
    return {showCMSBanner, showaAppBar}
}

export default checkBannerVisibility
